/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import { organizationAPI } from "libs/apiClient/Organization";
import {
	ActualThreatResponse,
	ActualViolatorResponse,
	BasicTacticResponse,
	CollusionGroupResponse,
	ImplementThreatWayResponse,
	InfluenceObjectResponse,
	RiskTypeResponse,
	ThreatImplementationAssessmentResponse,
	ThreatImplementationLevelResponse,
} from "libs/apiClient/data-contracts";

export const fetchRisksTableData = async (id: number): Promise<RiskTypeResponse[]> => {
	return await organizationAPI.objectRiskDetail(id).then(({ data }) => data);
};
export const fetchObjectOfImpactTableData = async (id: number): Promise<InfluenceObjectResponse[]> => {
	return await organizationAPI.objectInfluenceDetail(id).then(({ data }) => data);
};
export const fetchCollusionGroupTableData = async (id: number): Promise<CollusionGroupResponse[]> => {
	return await organizationAPI.objectCollusionDetail(id).then(({ data }) => data);
};
export const fetchAssessmentOfObjectivesTableData = async (
	id: number,
): Promise<string | ThreatImplementationAssessmentResponse[]> => {
	return await organizationAPI.objectAssessmentDetail(id).then(({ data }) => data);
};
export const fetchLevelsOfVariablesTableData = async (id: number): Promise<ThreatImplementationLevelResponse[]> => {
	return await organizationAPI.objectLevelDetail(id).then(({ data }) => data);
};
export const fetchViolatorsTableData = async (id: number): Promise<ActualViolatorResponse[]> => {
	return await organizationAPI.objectViolatorDetail(id).then(({ data }) => data);
};
export const fetchWayTableData = async (id: number): Promise<string | ImplementThreatWayResponse[]> => {
	return await organizationAPI.objectWayDetail(id).then(({ data }) => data);
};
export const fetchTacticTableData = async (id: number): Promise<BasicTacticResponse[]> => {
	return await organizationAPI.objectTacticDetail(id).then(({ data }) => data);
};
export const fetchActualTableData = async (id: number): Promise<ActualThreatResponse[]> => {
	return await organizationAPI.objectThreatsActualDetail(id).then(({ data }) => data);
};
